import { useParams, Link } from 'react-router-dom';
import { useFetch } from '../../hooks/useFetch';
import { servicesApi } from '../../api/servicesApi';
import { getServiceIcon } from '../../utils/serviceIcons';
import { Button } from '../../components/ui/Button';
import { SkeletonText } from '../../components/ui/Skeleton';
import { Seo } from '../../components/ui/Seo';
import './ServiceDetail.css';

const API_URL = process.env.REACT_APP_API_URL;

export function ServiceDetail() {
  const { id } = useParams();
  const { data: service, loading } = useFetch(() => servicesApi.get(id), [id]);

  if (loading) return <div className="prose-page"><SkeletonText lines={5} /></div>;
  if (!service) return <p className="prose-page">Service introuvable.</p>;

  const Icon = getServiceIcon(service.titre);

  return (
    <article className="section service-detail">
      <Seo
        title={service.titre}
        description={service.description_courte || service.description}
        path={`/particuliers/services/${service.id}`}
        image={service.image_url ? `${API_URL}${service.image_url}` : undefined}
      />

      <div className="container service-detail__grid">
        <div className="service-detail__media">
          {service.image_url ? (
            <img src={`${API_URL}${service.image_url}`} alt={service.titre} />
          ) : (
            <Icon className="service-detail__media-icon" strokeWidth={1.5} />
          )}
        </div>

        <div>
          <h1>{service.titre}</h1>
          {service.description_courte && <p className="service-detail__intro">{service.description_courte}</p>}
          <p className="service-detail__desc">{service.description}</p>

          <Link to="/devis">
            <Button>Demander un devis</Button>
          </Link>
        </div>
      </div>
    </article>
  );
}
